import { render, staticRenderFns } from "./quesInstru8.vue?vue&type=template&id=015b14f1"
import script from "./quesInstru8.vue?vue&type=script&lang=js"
export * from "./quesInstru8.vue?vue&type=script&lang=js"
import style0 from "./quesInstru8.vue?vue&type=style&index=0&id=015b14f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports